<template>
    <div class="text-white">
        <AppDialog
            closeable
            @close="closeDialog"
            :title="$t('pages_pricing_getMorePhotos')"
            v-if="showCreditPackDialog"
            :show="showCreditPackDialog"
        >
            <template #header>
                <div class="w-full flex justify-between items-center lg:mb-8 mb-12">
                    <div class="flex w-full lg:justify-normal justify-center items-center gap-8">
                        <p class="text-title-md font-bold text-gray-100">
                            {{ $t("pages_pricing_getMorePhotos") }}
                        </p>
                    </div>
                    <Icon
                        name="tabler:x"
                        size="24px"
                        @click="closeDialog"
                        class="text-gray-700 lg:!block !hidden cursor-pointer transition-all hover:text-gray-500"
                    />
                </div>
            </template>

            <template #default>
                <div class="lg:w-[540px]">
                    <PricingCreditPackCalculator
                        v-model="creditValue"
                        @change:amount="handleTotalAmount"
                        :ratio="userData.price_per_one_credit"
                    />

                    <div class="flex items-center justify-between lg:py-5 lg:mb-4 mb-12 lg:mt-8 mt-4">
                        <p class="text-body-md text-gray-500">{{ $t("pages_billing_expireDate") }}</p>
                        <p class="text-body-lg text-gray-100 font-bold">
                            {{
                                userData.will_be_roll_overed
                                    ? $t("pages_pricing_activeWhileSubscribed")
                                    : new Date(userData.plan_expire_date).toLocaleDateString()
                            }}
                        </p>
                    </div>

                    <div class="flex mb-4 items-center justify-between text-gray-100">
                        <p class="lg:text-title-sm text-body-lg">{{ $t("pages_pricing_totalPayment") }}</p>
                        <p class="font-bold lg:text-title-xl text-title-lg">${{ creditAmount }}</p>
                    </div>

                    <AppButton
                        block
                        size="lg"
                        @click="handleCheckout"
                        id="get-more-input-popup-checkout-button"
                        :state="status === 'pending' ? 'loading' : 'default'"
                    >
                        {{ $t("global_checkout") }}
                    </AppButton>
                </div>
            </template>
        </AppDialog>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
import PricingCreditPackCalculator from "./PricingCreditPackCalculator.vue";

const { showCreditPackDialog, showStripeForm, stripeSecretKey } = storeToRefs(usePricingStore());
const { submitCreditPack } = usePricingStore();

const { userData } = storeToRefs(useUserStore());

const creditValue = ref();

const creditAmount = ref();

function closeDialog() {
    showCreditPackDialog.value = false;
}

const handleTotalAmount = (amount: number) => {
    creditAmount.value = amount;
};
const { locale } = useI18n();
const { execute, status, data } = await submitCreditPack({ currency: "usd", quantity: creditValue }, locale.value);

const handleCheckout = async () => {
    await execute();

    if (data.value) {
        usePricingStore().showEmbeddedStripCheckout(data.value.client_secret);

        setTimeout(() => {
            closeDialog();
        }, 1000);
    }
};
</script>
